import classNames from 'classnames'
import { useState } from 'react'
import { makeTextFieldClear } from 'shared/ui/TextField/ActionsAside/TextFieldClear'
import { makeTextFieldElement } from 'shared/ui/TextField/ActionsAside/TextFieldElement'
import { makeTextFieldAutoFocus } from 'shared/ui/TextField/ActionsMain/TextFieldAutoFocus'
import { makeTextFieldBlurOnEnter } from 'shared/ui/TextField/ActionsMain/TextFieldBlurOnEnter'
import { InputNumeric } from 'shared/ui/TextField/Input/InputNumeric'
import { type IInputNumericProps } from 'shared/ui/TextField/Input/types'
import { TextField } from 'shared/ui/TextField/TextField'
import { Typography } from 'shared/ui/Typography'
import styles from './styles.module.scss'

type ITextFieldWithFixedTextProps = {
  fixedValue: string
  value: string
  defaultValue: string
  InputProps?: IInputNumericProps
  setValue: (value: string) => void
  blurCallback?: (value: string) => void
}

export const TextFieldWithFixedText = ({
  fixedValue,
  value,
  defaultValue,
  setValue,
  InputProps,
  blurCallback,
}: ITextFieldWithFixedTextProps) => {
  const [focus, setFocus] = useState(false)

  const handleChange = (inputValue: string) => {
    setValue(inputValue)
  }

  const handleBlur = () => {
    const correctedValue = value === '' ? defaultValue : value

    setFocus(false)
    if (value === '') {
      setValue(correctedValue)
    }

    blurCallback?.(correctedValue)
  }

  return (
    <TextField
      Input={InputNumeric}
      InputProps={
        {
          value: value,
          placeholder: '1',
          maxLength: 3,
          style: { width: value.length * 9 },
          isAllowed: (values) => {
            const { floatValue, value: stringValue } = values

            if (!stringValue || stringValue === '') {
              return true
            }

            return floatValue !== undefined && floatValue >= 1 && floatValue <= 999
          },
          ...InputProps,
        } as IInputNumericProps
      }
      className={classNames(styles.label, {
        [styles.collapsed]: Boolean(!focus),
      })}
      onChange={handleChange}
      onFocus={() => setFocus(true)}
      onBlur={handleBlur}
      size={'small'}
      variant={'stroke'}
      mainActions={[makeTextFieldAutoFocus({ withFocus: false }), makeTextFieldBlurOnEnter()]}
      rightActions={[
        makeTextFieldElement({
          element: (
            <Typography variant={'text-input-field'} color='tertiary' ariaLabel={'contacts'}>
              {fixedValue}
            </Typography>
          ),
        }),
        makeTextFieldClear(),
      ]}
    />
  )
}
